var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "sidebar-title"
  }, [_c('h2', [_vm._v("科隆云")]), _c('div', {
    staticClass: "namezh"
  }, [_vm._v(_vm._s(_vm.$route.meta.namezh))])]), _c('Menu', {
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "theme": "dark",
      "mode": "horizontal",
      "active-name": _vm.$route.name,
      "width": "158px"
    }
  }, [_c('Submenu', {
    attrs: {
      "name": "我的"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("我的 ")], 1), _c('MenuItem', {
    attrs: {
      "name": "task",
      "to": "/home/task"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("任务 ")], 1)], 2), _vm.displayMenu.customer || _vm.displayMenu.salesRecord || _vm.displayMenu.tankRental || _vm.displayMenu.sales_order || _vm.displayMenu.tech_service || _vm.displayMenu.receive ? _c('Submenu', {
    attrs: {
      "name": "客户管理"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("客户管理 ")], 1), _vm.displayMenu.customer ? _c('MenuItem', {
    attrs: {
      "name": "customer",
      "to": "/home/customer"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("客户 ")], 1) : _vm._e(), _vm.displayMenu.customerAnalyze ? _c('MenuItem', {
    attrs: {
      "name": "customerAnalyze",
      "to": "/home/customer_analyze"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("客户分析 ")], 1) : _vm._e(), _vm.displayMenu.salesRecord ? _c('MenuItem', {
    attrs: {
      "name": "salesRecord",
      "to": "/home/salesRecord"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("销售记录 ")], 1) : _vm._e(), _vm.displayMenu.tankRental ? _c('MenuItem', {
    attrs: {
      "name": "storageTank",
      "to": "/home/storageTank"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("储罐列表 ")], 1) : _vm._e(), _vm.displayMenu.tankRental ? _c('MenuItem', {
    attrs: {
      "name": "tankRental",
      "to": "/home/tankRental"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("储罐借用 ")], 1) : _vm._e(), _vm.displayMenu.sales ? _c('MenuItem', {
    attrs: {
      "name": "sales",
      "to": "/home/sales"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("销售项目 ")], 1) : _vm._e(), _vm.displayMenu.sales ? _c('MenuItem', {
    attrs: {
      "name": "JDItemCodeCheck",
      "to": "/home/jd_item_code_check"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("金蝶云物料核对 ")], 1) : _vm._e(), _vm.displayMenu.salesRecord ? _c('MenuItem', {
    attrs: {
      "name": "salesPlan",
      "to": "/home/salesPlan"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("销售计划 ")], 1) : _vm._e(), _vm.displayMenu.tech_service ? _c('MenuItem', {
    attrs: {
      "name": "recipe",
      "to": "/home/recipe"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("配方管理 ")], 1) : _vm._e(), _vm.displayMenu.tech_service || _vm.displayMenu.finance ? _c('MenuItem', {
    attrs: {
      "name": "tech_service",
      "to": "/home/tech_service"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("技术服务 ")], 1) : _vm._e(), _vm.displayMenu.tech_service || _vm.displayMenu.finance ? _c('MenuItem', {
    attrs: {
      "name": "tech_service_stat",
      "to": "/home/tech_service_stat"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("技术统计 ")], 1) : _vm._e(), _vm.displayMenu.customer_develop ? _c('MenuItem', {
    attrs: {
      "name": "customer_develop",
      "to": "/home/customer_develop"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("客户开发 ")], 1) : _vm._e(), _vm.displayMenu.customer_develop ? _c('MenuItem', {
    attrs: {
      "name": "import_customer_qz_table",
      "to": "/home/import_customer_qz_table"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("权责表 ")], 1) : _vm._e(), _vm.displayMenu.customer_develop ? _c('MenuItem', {
    attrs: {
      "name": "customer_qz_review",
      "to": "/home/customer_qz_review"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("权责审核 ")], 1) : _vm._e(), _vm.displayMenu.customer_contact ? _c('MenuItem', {
    attrs: {
      "name": "customer_contact",
      "to": "/home/customer_contact"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("联系人 ")], 1) : _vm._e(), _vm.displayMenu.customer_contact ? _c('MenuItem', {
    attrs: {
      "name": "sales_promo_fee",
      "to": "/home/sales_promo_fee"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("业务费 ")], 1) : _vm._e(), _vm.displayMenu.cacl_sales_cost ? _c('MenuItem', {
    attrs: {
      "name": "sales_order_profit",
      "to": "/home/sales_order_profit"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("客户利润 ")], 1) : _vm._e()], 2) : _vm._e(), _vm.displayMenu.receive ? _c('Submenu', {
    attrs: {
      "name": "回款"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("回款 ")], 1), _vm.displayMenu.receive ? _c('MenuItem', {
    attrs: {
      "name": "receiveChart",
      "to": "/home/receive_chart"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("回款统计 ")], 1) : _vm._e(), _vm.displayMenu.arTable ? _c('MenuItem', {
    attrs: {
      "name": "importARTable",
      "to": "/home/importARTable"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("账龄 ")], 1) : _vm._e(), _vm.displayMenu.receive ? _c('MenuItem', {
    attrs: {
      "name": "receive",
      "to": "/home/receive"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("回款记录 ")], 1) : _vm._e(), _vm.displayMenu.arTable ? _c('MenuItem', {
    attrs: {
      "name": "receive_task",
      "to": "/home/receive_task"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("回款任务 ")], 1) : _vm._e(), _vm.displayMenu.arTable ? _c('MenuItem', {
    attrs: {
      "name": "receive_task_stat",
      "to": "/home/receive_task_stat"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("回款任务统计 ")], 1) : _vm._e(), _vm.displayMenu.arTable ? _c('MenuItem', {
    attrs: {
      "name": "duizhangdan_list",
      "to": "/home/duizhangdan_list"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("对账单列表 ")], 1) : _vm._e()], 2) : _vm._e(), _vm.displayMenu.raw_material || _vm.displayMenu.semi_material || _vm.displayMenu.product ? _c('Submenu', {
    attrs: {
      "name": "物料管理"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("物料管理 ")], 1), _vm.displayMenu.raw_material ? _c('MenuItem', {
    attrs: {
      "name": "raw_material",
      "to": "/home/raw_material"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("原材料 ")], 1) : _vm._e(), _vm.displayMenu.semi_material ? _c('MenuItem', {
    attrs: {
      "name": "semi_material",
      "to": "/home/semi_material"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("母液 ")], 1) : _vm._e(), _vm.displayMenu.semi_material ? _c('MenuItem', {
    attrs: {
      "name": "semi_Item",
      "to": "/home/semi_Item"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("母液项目 ")], 1) : _vm._e(), _vm.displayMenu.product ? _c('MenuItem', {
    attrs: {
      "name": "product",
      "to": "/home/product"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("产品 ")], 1) : _vm._e(), _vm.displayMenu.cacl_purchase_cost ? _c('MenuItem', {
    attrs: {
      "name": "caclPurchase",
      "to": "/home/caclPurchase"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("材料成本 ")], 1) : _vm._e(), _vm.user.superAdmin ? _c('MenuItem', {
    attrs: {
      "name": "caclMLCost",
      "to": "/home/caclMLCost"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("母液成本 ")], 1) : _vm._e(), _vm.displayMenu.cacl_sales_cost ? _c('MenuItem', {
    attrs: {
      "name": "caclSalesCost",
      "to": "/home/caclSalesCost"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("客户成本 ")], 1) : _vm._e()], 2) : _vm._e(), _vm.displayMenu.sales_order ? _c('Submenu', {
    attrs: {
      "name": "销售订单"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("销售订单 ")], 1), _vm.displayMenu.sales_order ? _c('MenuItem', {
    attrs: {
      "name": "sales_order",
      "to": "/home/sales_order"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("销售订单 ")], 1) : _vm._e(), _vm.displayMenu.sales_order ? _c('MenuItem', {
    attrs: {
      "name": "sales_order_table",
      "to": "/home/sales_order_table"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("销售订单列表 ")], 1) : _vm._e(), _vm.displayMenu.vehicle ? _c('MenuItem', {
    attrs: {
      "name": "vehicle",
      "to": "/home/vehicle"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("车辆信息 ")], 1) : _vm._e(), _vm.displayMenu.sales_prod_order ? _c('MenuItem', {
    attrs: {
      "name": "sales_prod_order",
      "to": "/home/sales_prod_order"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("销售生产订单 ")], 1) : _vm._e(), _vm.displayMenu.sales_order ? _c('MenuItem', {
    attrs: {
      "name": "sales_order_vol",
      "to": "/home/sales_order_vol"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-color-filter"
    }
  }), _vm._v("销量统计 ")], 1) : _vm._e()], 2) : _vm._e(), _vm.displayMenu.purchase ? _c('Submenu', {
    attrs: {
      "name": "机构"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("机构 ")], 1), _vm.displayMenu.purchase ? _c('MenuItem', {
    attrs: {
      "name": "supplier",
      "to": "/home/supplier"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("供应商 ")], 1) : _vm._e(), _vm.displayMenu.purchase ? _c('MenuItem', {
    attrs: {
      "name": "entity",
      "to": "/home/entity"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("机构 ")], 1) : _vm._e()], 2) : _vm._e(), _vm.displayMenu.finance_sales ? _c('Submenu', {
    attrs: {
      "name": "财务管理"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("财务管理 ")], 1), _vm.displayMenu.purchase ? _c('MenuItem', {
    attrs: {
      "name": "payment",
      "to": "/home/payment"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("付款记录 ")], 1) : _vm._e(), _vm.displayMenu.finance ? _c('MenuItem', {
    attrs: {
      "name": "bankAccount",
      "to": "/home/bank_account"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("收款账号 ")], 1) : _vm._e(), _vm.displayMenu.finance_sales ? _c('MenuItem', {
    attrs: {
      "name": "bill",
      "to": "/home/bill"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("票据 ")], 1) : _vm._e(), _vm.displayMenu.finance_sales ? _c('MenuItem', {
    attrs: {
      "name": "importFileProcess",
      "to": "/home/importFileProcess"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("出库单 ")], 1) : _vm._e(), _vm.displayMenu.finance_sales ? _c('MenuItem', {
    attrs: {
      "name": "outStoreStat",
      "to": "/home/outStoreStat"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("出库单统计 ")], 1) : _vm._e()], 2) : _vm._e(), _vm.displayMenu.company_setting || _vm.displayMenu.factory || _vm.displayMenu.user ? _c('Submenu', {
    attrs: {
      "name": "公司设置"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-stats"
    }
  }), _vm._v("公司设置 ")], 1), _vm.displayMenu.company_setting ? _c('MenuItem', {
    attrs: {
      "name": "company",
      "to": "/home/company"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("公司 ")], 1) : _vm._e(), _vm.displayMenu.factory ? _c('MenuItem', {
    attrs: {
      "name": "factory",
      "to": "/home/factory"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("工厂 ")], 1) : _vm._e(), _vm.displayMenu.user ? _c('MenuItem', {
    attrs: {
      "name": "usermanagement",
      "to": "/home/usermanagement"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-contacts"
    }
  }), _vm._v("用户和权限 ")], 1) : _vm._e()], 2) : _vm._e()], 1), _vm.user ? _c('Dropdown', {
    staticStyle: {
      "margin-left": "auto",
      "padding-right": "12px",
      "height": "40px",
      "line-height": "40px",
      "cursor": "pointer",
      "background": "#515a6e",
      "color": "#fff"
    },
    attrs: {
      "trigger": "click",
      "placement": "bottom-end"
    },
    on: {
      "on-click": _vm.goUserPage
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.user.name) + " "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "setting"
    }
  }, [_vm._v("个人设置")]), _c('DropdownItem', {
    attrs: {
      "name": "changPassword"
    }
  }, [_vm._v("修改密码")]), _c('DropdownItem', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "name": "logout"
    }
  }, [_vm._v("退出登录")])], 1)], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "width": "300",
      "okText": "确认退出"
    },
    on: {
      "on-ok": _vm.logoutFunc
    },
    model: {
      value: _vm.logoutModal,
      callback: function ($$v) {
        _vm.logoutModal = $$v;
      },
      expression: "logoutModal"
    }
  }, [_c('h3', [_vm._v("确认退出登录？")])]), _c('Modal', {
    attrs: {
      "title": "修改用户密码",
      "width": "300"
    },
    model: {
      value: _vm.changePasswordModal,
      callback: function ($$v) {
        _vm.changePasswordModal = $$v;
      },
      expression: "changePasswordModal"
    }
  }, [_c('Form', {
    ref: "changePasswordForm",
    attrs: {
      "model": _vm.changePasswordForm,
      "rules": _vm.changePasswordValidate
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请输入旧密码",
      "prop": "oldPassword"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "旧密码"
    },
    model: {
      value: _vm.changePasswordForm.oldPassword,
      callback: function ($$v) {
        _vm.$set(_vm.changePasswordForm, "oldPassword", $$v);
      },
      expression: "changePasswordForm.oldPassword"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "请输入新密码",
      "prop": "newPassword"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "新密码"
    },
    model: {
      value: _vm.changePasswordForm.newPassword,
      callback: function ($$v) {
        _vm.$set(_vm.changePasswordForm, "newPassword", $$v);
      },
      expression: "changePasswordForm.newPassword"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.submitChangePassword('changePasswordForm');
      }
    }
  }, [_vm._v("确定修改")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }